import type { ComponentProps } from "react";
import type { ChatActiveThreadHeader } from "./ChatActiveThreadHeader";
import type { LoadedSurfaceInput } from "./buildChatLoadedThreadSurfaceProps";
import { buildAgentsPanelViewModel } from "../agents/agentsPanel.logic";
type HeaderProps = ComponentProps<typeof ChatActiveThreadHeader>;
export function buildHeaderProps(input: LoadedSurfaceInput): HeaderProps {
  return {
    activeProject: input.activeProject,
    onRunScript: input.onRunScript,
    activeThreadTitle: input.activeThread.title,
    activeThreadKind: input.activeThread.kind,
    activeThreadWorkerRole: input.activeThread.workerRole,
    activeThreadParentId: input.activeThread.parentThreadId,
    activeThreadParentTitle: input.activeThreadParentTitle,
    activeThreadWorkerCount: input.activeThreadWorkerCount,
    jumpToParentShortcutLabel: input.jumpToParentShortcutLabel,
    onJumpToParent: input.onJumpToParent,
    isServerThread: input.isServerThread,
    canOpenRightSidebar: input.canOpenRightSidebar,
    previewOpen: input.previewOpen,
    canvasOpen: input.canvasOpen,
    diffOpen: input.diffOpen,
    planOpen: input.planOpen,
    terminalOpen: Boolean(input.terminalState.terminalOpen),
    terminalRunningCount: input.terminalState.runningTerminalIds.length,
    activeAgentCount: buildAgentsPanelViewModel({
      workers: (input.activeThreadTeam?.workers ?? []).map((worker) => ({
        id: worker.id,
        title: worker.title,
        status: worker.status,
        branch: worker.branch,
        modelLabel: null,
        createdAt: worker.createdAt,
        updatedAt: worker.updatedAt,
        workerRole: worker.workerRole,
      })),
    }).activeCount,
    onTogglePreview: input.onTogglePreview,
    onToggleCanvas: input.onToggleCanvasInvert,
    onToggleDiff: input.onToggleDiff,
    onTogglePlan: input.togglePlanSidebar,
    onToggleTerminal: input.toggleTerminalVisibility,
    previewShortcutLabel: input.previewPanelShortcutLabel,
    canvasShortcutLabel: input.canvasPanelShortcutLabel,
    diffShortcutLabel: input.diffPanelShortcutLabel,
    planShortcutLabel: input.planPanelShortcutLabel,
    terminalShortcutLabel: input.terminalToggleShortcutLabel,
    showPanelLauncher: input.showRightPanelLauncher,
    gitCwd: input.gitCwd,
    activeThreadRef: input.activeThreadRef,
    routeKind: input.routeKind,
    draftId: input.draftId ?? undefined,
  };
}
